import { engApi } from "./engApi";
import axios from "axios";

export const getCompany = async () => {
  const response = await engApi.get("/company/");

  return response.data;
};

export const getSchoolYear = async () => {
  const response = await engApi.get("/getSchoolYear");
  const data = response.data;
  // Local override for admin testing
  try {
    const override = localStorage.getItem("adminSchoolYearOverride");
    if (override) {
      return { ...data, school_yrs: parseInt(override, 10) };
    }
  } catch {}
  return data;
};

export const getSchoolYearB = async () => {
  const response = await engApi.get("/getSchoolYearB");
  const data = response.data;
  // Local override for admin testing
  try {
    const override = localStorage.getItem("adminSchoolYearDsbiOverride");
    if (override) {
      return { ...data, school_yrs: parseInt(override, 10) };
    }
  } catch {}
  return data;
};

// Admin: update School Year (Global) - internship
export const setSchoolYear = async (schoolYear) => {
  // Use different base URL for setSchoolYear
  const ts = Date.now();
  console.log('setSchoolYear calling API with:', schoolYear);
  const url = `https://eng.buu.ac.th/internship/interntest/intern-api/setSchoolYear.php?school_yrs=${schoolYear}&_=${ts}`;
  console.log('API URL:', url);
  
  try {
    const response = await axios.get(url);
    console.log('API Response:', response.data);
    return response.data;
  } catch (error) {
    console.error('API Error:', error);
    throw error;
  }
};

// Admin: update School Year (Global) - cooperative (dsbi)
export const setSchoolYearB = async (schoolYear) => {
  // Use different base URL for setSchoolYearB
  const ts = Date.now();
  const response = await axios.get(`https://eng.buu.ac.th/internship/interntest/intern-api/setSchoolYearB.php?school_yrs=${schoolYear}&_=${ts}`);
  return response.data;
};

export const getAllStudent = async () => {
  const response = await engApi.get("/all-student/");

  return response.data;
};
export const getJdInternData = async () => {
  const response = await engApi.get("/jd-intern-data/");

  return response.data;
};

export const getInternStudent = async () => {
  const response = await engApi.get("/intern-student/");

  return response.data;
};

export const getInternStudent2 = async () => {
  const response = await engApi.get("/intern-student2/");

  return response.data;
};

export const getInternStudent3 = async (selectedYear) => {
  const response = await engApi.get("/intern-student2?school_yrs=" + selectedYear);

  return response.data;
};

export const getAllStaff = async () => {
  const response = await engApi.get("/all-staff/");

  return response.data;
};

export const getFormAnswer = async () => {
  const response = await engApi.get("/form-answer/");

  return response.data;
};

export const getEvent = async () => {
  const response = await engApi.get("/pretraining/");

  return response.data;
};
export const getActivityLog = async () => {
  const response = await engApi.get("/activity-log/");

  return response.data;
};

export const getActivityLogById = async (stId) => {
  const response = await engApi.get(`/activity-log-by-id?st_id=${stId}`);

  return response.data;
};

export const getEventById = async (event_id) => {
  const response = await engApi.get(`/event-by-id?event_id=${event_id}`);

  return response.data;
};

export const getScoreTrainingLog = async () => {
  const response = await engApi.get("/score-training-log/");

  return response.data;
};

export const getFullTraingLog = async () => {
  const resActivity = await engApi.get("/activity-log/");
  const resPretraining = await engApi.get("/pretraining/");

  const mapData = resActivity.data
    .filter((data) => data.type === "เข้า")
    .map((el) => {
      return {
        ...el,
        eventData: resPretraining.data.find((item) => item.id === el.event_id),
      };
    });

  return mapData;
};

export const getInternshipRequest = async () => {
  const response = await engApi.get("/get-internship-request/");

  return response.data;
};

export const getInternshipRequest2 = async () => {
  const response = await engApi.get("/get-internship-request2/");

  return response.data;
};

export const getInternshipRequest3 = async (selectedYear) => {
  const response = await engApi.get("/get-internship-request2?school_yrs=" + selectedYear);

  return response.data;
};



export const getDocumentRequest = async () => {
  const response = await engApi.get("/document-request/");

  return response.data;
};
export const getDocumentRequestByYear = async (school_year) => {
  const response = await engApi.get(
    `/document-request-by-year?school_year=${school_year}`
  );

  return response.data;
};

export const getDocumentReqStudent = async () => {
  const response = await engApi.get("/document-req-student/");

  return response.data;
};

export const postEvent = async ({
  event_id,
  event_title,
  event_date,
  event_time,
  expert,
  place,
  Year,
}) => {
  const response = await engApi.post(
    `/event?event_id=${event_id}&event_title=${event_title}&event_date=${event_date}&event_time=${event_time}&expert=${expert}&place=${place}&Year=${Year}`
  );

  return response.data;
};

export const postInternManual = async ({
  internRequestId,
  manualData,
  year,
}) => {
  const response = await engApi.post(
    `/intern-manual?intern_request_id=${internRequestId}&manual_data=${manualData}&year=${year}`
  );

  return response.data;
};
export const putInternManual = async ({ internRequestId, manualData }) => {
  const response = await engApi.put(
    `/intern-manual?intern_request_id=${internRequestId}&manual_data=${manualData}`
  );

  return response.data;
};

export const getInternManualById = async (internRequestId) => {
  // https://eng.buu.ac.th/internship/intern-api/intern-manual?intern_request_id=6205047201

  const response = await engApi.get(
    `/intern-manual?intern_request_id=${internRequestId}`
  );

  return response.data;
};

export const getInternshipRequestById = async (internRequestId) => {
  const response = await engApi.get(
    `/get-internship-request-by-Id?intern_request_id=${internRequestId}`
  );

  return response.data;
};

export const getInternshipRequestBySt_id = async (st_id) => {
  const response = await engApi.get(
    `/get-internship-request-by-stid?st_id=${st_id}`
  );

  return response.data;
};

export const getAllManual = async () => {
  const response = await engApi.get("/intern-manual");

  return response.data;
};

export const getAllProposalCoop = async () => {
  const response = await engApi.get("/coop-proposal");

  return response.data;
};


export const getLogbookById = async (internRequestId) => {
  const response = await engApi.get(
    `/get-doclogbook-by-Id?intern_request_id=${internRequestId}`
  );

  return response.data;
};

export const getInternReportById = async (internRequestId) => {
  const response = await engApi.get(
    `/get-docinternreport-by-Id?intern_request_id=${internRequestId}`
  );

  return response.data;
};

export const getCoopReportById = async (internRequestId) => {
  const response = await engApi.get(
    `/get-doccoopreport-by-Id?intern_request_id=${internRequestId}`
  );

  return response.data;
};

export const getAlllogbook = async () => {
  const response = await engApi.get("/get-doclogbook/");

  return response.data;
};

export const getAllinternreport = async () => {
  const response = await engApi.get("/get-docinternreport/");

  return response.data;
};

export const getAllcoopreport = async () => {
  const response = await engApi.get("/get-doccoopreport/");

  return response.data;
};

export const getInternshipReject = async () => {
  const response = await engApi.get("/internship-reject/");

  return response.data ?? [];
};

export const getAssessmentByStId = async (st_id) => {
  const response = await engApi.get(`/assessment-visit?req_id=${st_id}`);

  return response.data;
};

export const getAssessmentCoopByStId = async (st_id) => {
  const response = await engApi.get(`/assessment-visitcoop?req_id=${st_id}`);

  return response.data;
};

export const getAssessment = async () => {
  const response = await engApi.get(`/assessment-visit`);

  return response.data;
};
export const getAssessmentCoop = async () => {
  const response = await engApi.get(`/assessment-visitcoop`);

  return response.data;
};

export const getAssessment_report = async () => {
  const response = await engApi.get(`/assessment-report`);

  return response.data;
};

export const getAssessment_reportcoop = async () => {
  const response = await engApi.get(`/assessment-reportcoop`);

  return response.data;
};

export const getAssessment_presentcoop = async () => {
  const response = await engApi.get(`/assessment-presentcoop`);

  return response.data;
};

export const getAssessment_company = async () => {
  const response = await engApi.get(`/assessment-company`);

  return response.data;
};

export const getTotalScoreOnly = async (req_id) => {
  const response = await engApi.get(`/internship-scores?req_id=${req_id}&action=score_only`);
  return response.data;
};

export const getAssessment_companycoop = async () => {
  const response = await engApi.get(`/assessment-companycoop`);

  return response.data;
};

export const getAssessmentReportByStId = async (st_id) => {
  const response = await engApi.get(`/assessment-report?req_id=${st_id}`);

  return response.data;
};

export const getAssessmentPresentCoopByStId = async (st_id) => {
  const response = await engApi.get(`/assessment-presentcoop?req_id=${st_id}`);

  return response.data;
};

export const addResponseAssessmentByStId = async (st_id, params, new_) => {

  const response = await engApi.get(`/add-assessment-visit?req_id=${st_id}&new_=${new_}`,
   {
    params,
  });

  return response.data;
};

export const addResponseAssessmentCoopByStId = async (st_id, params, new_) => {

  const response = await engApi.get(`/add-assessment-visitcoop?req_id=${st_id}&new_=${new_}`,
   {
    params,
  });

  return response.data;
};

export const addAssessmentCompanyByStId = async (params) => {

  const response = await engApi.get(`/add-assessment-company`,
   {
    params,
  });

  return response.data;
};

export const addAssessmentCompanyCoopByStId = async (params) => {

  const response = await engApi.get(`/add-assessment-companycoop`,
   {
    params,
  });

  return response.data;
};

export const addAssessmentCompanyCoopMulti = async (params) => {
  const response = await engApi.get(`/add-assessment-companycoopmulti`, {
    params,
  });
  return response.data;
};

export const addAssessmentReportCoopByStId = async (params) => {

  const response = await engApi.get(`/add-assessment-reportcoop`,
   {
    params,
  });

  return response.data;
};

export const addAssessmentReportCoopMulti = async (params) => {
  const response = await engApi.get(`/add-assessment-reportcoopmulti`, {
    params,
  });
  return response.data;
};


export const addResponseAssessmentReportByStId = async (st_id, params, new_) => {

  const response = await engApi.get(`/add-assessment-report?req_id=${st_id}&new_=${new_}`,
   {
    params,
  });

  return response.data;
};

export const addResponseAssessmentPresentCoopByStId = async (st_id, params, new_) => {

  const response = await engApi.get(`/add-assessment-presentcoop?req_id=${st_id}&new_=${new_}`,
   {
    params,
  });

  return response.data;
};



export const getJoinDataByCompany = async () => {
  const internStudent = await getInternStudent();
  const allCompany = await getCompany();
  const internshipRequest = await getInternshipRequest();

  const studentDetail = internStudent.map((st) => {
    const find = internshipRequest.find((el) => el.st_id === st.id);

    return {
      ...st,
      internDetail: find,
    };
  });

  const companyWithStd = allCompany.map((company) => {
    const internSt = studentDetail.filter(
      (st) => st.internDetail?.cp_id === company.id
    );

    return {
      ...company,
      internStudent: internSt,
    };
  });

  return companyWithStd;
};

export const getInternshipScores = async () => {
  const response = await engApi.get(`/internship-scores`);
  return response.data;
};

export const getInternRequestWithFullData = async () => {
  const internshipRequest = await getInternshipRequest2();
  const internStudent = await getInternStudent2();
  const allCompany = await getCompany();
  const internManual = await getAllManual();
  const doclogbook = await getAlllogbook();
  const allInternReport = await getAllinternreport();
  const allCoopReport = await getAllcoopreport();

  const assessment_visit = await getAssessment();
  const assessment_report = await getAssessment_report();
  const assessment_company = await getAssessment_company();
  const internshipScores = await getInternshipScores();

  const internshipReqStd = await internshipRequest.map((intern) => {
    const internStd = internStudent.find((st) => st.id === intern.st_id);
    const comp = allCompany.find((company) => company.id === intern?.cp_id);
    const internMnl = internManual.find(
      (int) => int.intern_request_id === intern.req_id
    );

    const internReport = allInternReport.find(
      (report) => report.req_id === intern?.req_id
    );

    const coopReport = allCoopReport.find(
      (report) => report.req_id === intern?.req_id
    );

    let internLogbook = (doclogbook ?? []).filter(
      (book) => book.req_id === intern?.req_id
    );

    internLogbook.sort((a, b) => a.no - b.no);

    
    const totalScore = internshipScores
      .find((score) => score.req_id === intern.req_id)
    
    
  

    return {
      ...intern,
      internStudent: internStd,
      company: comp,
      internLocation: internMnl,
      doclogbook: internLogbook,
      internReport,
      coopReport,
      assessment_visit: assessment_visit.find(
        (el) => el.req_id === intern.req_id
      ),
      assessment_report: assessment_report.find(
        (el) => el.req_id === intern.req_id
      ),
      assessment_company: assessment_company.find(
        (el) => el.req_id === intern.req_id 
      ) || parseInt(totalScore?.total_score_85) || 0,

    };
  });

  

  return internshipReqStd;
};


export const getCoopRequestWithFullData = async () => {
  const internshipRequest = await getInternshipRequest2().then((res) => 
    res.filter((el) => el.type_internship !== 1));
  
  const internStudent = await getInternStudent2();
  const allCompany = await getCompany();
  const internManual = await getAllManual();
  const proposalCoop = await getAllProposalCoop();
  const doclogbook = await getAlllogbook();
  const allInternReport = await getAllinternreport();
  const allCoopReport = await getAllcoopreport();


  const assessment_visit = await getAssessmentCoop();
  const assessment_presentcoop = await getAssessment_presentcoop();
  const assessment_report = await getAssessment_reportcoop();

  

  const assessment_company = await getAssessment_companycoop();

  // Build fast lookup maps with normalized keys to avoid mismatch (string vs number / whitespace)
  const assessmentReportMap = new Map(
    (assessment_report || []).map((r) => [String(r?.req_id ?? "").trim(), r])
  );


  const internshipReqStd = await internshipRequest.map((intern) => {
    const internStd = internStudent.find((st) => st.id === intern.st_id)
   
    ;
    const comp = allCompany.find((company) => company.id === intern?.cp_id);
    const internMnl = internManual.find(
      (int) => int.intern_request_id === intern.req_id
    );

    const internReport = allInternReport.find(
      (report) => report.req_id === intern?.req_id
    );

    const coopReport = allCoopReport.find(
      (report) => report.req_id === intern?.req_id
    );

    let internLogbook = (doclogbook ?? []).filter(
      (book) => book.req_id === intern?.req_id
    );

    internLogbook.sort((a, b) => a.no - b.no);

    return {
      ...intern,
      internStudent: internStd,
      company: comp,
      internLocation: internMnl,
      doclogbook: internLogbook,
      internReport,
      coopReport,
      proposalCoop: proposalCoop.find(
        (el) => el.req_id === intern.req_id
      ),
      assessment_visit: assessment_visit.find(
        (el) => el.req_id === intern.req_id
      ),
      assessment_present: assessment_presentcoop.find(
        (el) => el.req_id === intern.req_id
      ),
      assessment_report: assessmentReportMap.get(String(intern.req_id).trim()),
      
      assessment_company: assessment_company.find(
        (el) => el.req_id === intern.req_id
      ),
    };
  });
  
  return internshipReqStd;
};



export const getInternRequestWithFullData2 = async (selectedYear) => {
  const internshipRequest = await getInternshipRequest3(selectedYear);
  const internStudent = await getInternStudent3(selectedYear);
  const allCompany = await getCompany();
  const internManual = await getAllManual();
  const doclogbook = await getAlllogbook();
  const allInternReport = await getAllinternreport();
  const allCoopReport = await getAllcoopreport();
  const assessment_visit = await getAssessment();
  const assessment_report = await getAssessment_report();
  const assessment_company = await getAssessment_company();

  const internshipReqStd = await internshipRequest.map((intern) => {
    const internStd = internStudent.find((st) => st.id === intern.st_id);
    const comp = allCompany.find((company) => company.id === intern?.cp_id);
    const internMnl = internManual.find(
      (int) => int.intern_request_id === intern.req_id
    );

    const internReport = allInternReport.find(
      (report) => report.req_id === intern?.req_id
    );
    const coopReport = allCoopReport.find(
      (report) => report.req_id === intern?.req_id
    );

    let internLogbook = (doclogbook ?? []).filter(
      (book) => book.req_id === intern?.req_id
    );

    internLogbook.sort((a, b) => a.no - b.no);

    return {
      ...intern,
      internStudent: internStd,
      company: comp,
      internLocation: internMnl,
      doclogbook: internLogbook,
      internReport,
      coopReport,
      assessment_visit: assessment_visit.find(
        (el) => el.req_id === intern.req_id
      ),
      assessment_report: assessment_report.find(
        (el) => el.req_id === intern.req_id
      ),
      assessment_company: assessment_company.find(
        (el) => el.req_id === intern.req_id
      ),
    };
  });

  return internshipReqStd;
};



export const updateStudentSupervisor = async (
  req_id,
  supervisorId,
  updatedby
) => {
  const response = await engApi.get(
    `/update-internship-request?req_id=${req_id}&supervisor=${supervisorId}&supervisorby=${updatedby}`
  );

  return response.data;
};



export const postAddLogbook = async (req_id, no, link) => {
  // var data = {
  //   'req_id': req_id,
  //   'no': no,
  //   'link': link,
  //  }

  const response = await engApi.get(
    `/add-doclogbook?req_id=${req_id}&no=${no}&link=${link}`
  );

  return response.data;
};

export const getProposalById = async (st_id) => {
  const response = await engApi.get(
    `/get-proposal-by-Id?intern_request_id=${st_id}`
  );

  return response.data;
};

export const postAddProposal = async (req_id, link) => {
  const response = await engApi.get(
    `/add-proposal?req_id=${req_id}&link=${link}`
  );

  return response.data;
};

export const putProposal = async (req_id, link) => {
  const response = await engApi.get(
    `/edit-proposal?req_id=${req_id}&link=${link}`
  );

  return response.data;
};

export const postAddInternReport = async (req_id, link) => {
  // var data = {
  //   'req_id': req_id,
  //   'no': no,
  //   'link': link,
  //  }

  const response = await engApi.get(
    `/add-docinternreport?req_id=${req_id}&link=${link}`
  );

  return response.data;
};

export const postAddCoopReport = async (req_id, link) => {
  // var data = {
  //   'req_id': req_id,
  //   'no': no,
  //   'link': link,
  //  }

  const response = await engApi.get(
    `/add-doccoopreport?req_id=${req_id}&link=${link}`
  );

  return response.data;
};

export const postEditLogbook = async (req_id, no, link) => {
  // const  data = JSON.stringify({
  //   'req_id': req_id,
  //   'no': no,
  //   'link': link
  // });
  // console.log(data);

  const response = await engApi.get(
    `/edit-doclogbook?req_id=${req_id}&no=${no}&link=${link}`
  );

  return response.data;
};

export const postEditInternReport = async (req_id, link) => {
  // const  data = JSON.stringify({
  //   'req_id': req_id,
  //   'no': no,
  //   'link': link
  // });
  // console.log(data);

  const response = await engApi.get(
    `/edit-docinternreport?req_id=${req_id}&link=${link}`
  );

  return response.data;
};

export const postEditCoopReport = async (req_id, link) => {
  // const  data = JSON.stringify({
  //   'req_id': req_id,
  //   'no': no,
  //   'link': link
  // });
  // console.log(data);

  const response = await engApi.get(
    `/edit-doccoopreport?req_id=${req_id}&link=${link}`
  );

  return response.data;
};

export const updateRatingLogbook = async (id, rating, markBy) => {
  const response = await engApi.get(`/updateRatingLogbook?id=${id}&mark=${rating}&markBy=${markBy}`);

  return response.data;
};

export const updateRatingInternManual = async (id, rating, markBy) => {
  const response = await engApi.get(`/updateRatingInternManual?id=${id}&mark=${rating}&markBy=${markBy}`);

  return response.data;
};

export const updateRatingProposal = async (req_id, rating, markBy) => {
  // Some API variants expect `id` instead of `req_id` and may ignore query strings
  // when a trailing slash is present. Send both keys via axios params to be safe.
  const response = await engApi.get(`/updateRatingProposal`, {
    params: {
      req_id,            // preferred by new API
      id: req_id,        // backward-compat: some endpoints read `id`
      mark: rating,
      markBy: markBy,
    }
  });
  return response.data;
};

// New functions for internship evaluation display
export const getInternshipScoreByReqId = async (reqId) => {
  const response = await engApi.get(`/internship-scores?req_id=${reqId}`);
  return response.data;
};

export const getScoreComparison = async (req_id) => {
  const response = await engApi.get(`/internship-scores?req_id=${req_id}&action=comparison`);
  return response.data;
};

export const addInternshipEvaluations = async (params) => {

  const response = await engApi.get(`/add-internship-evaluations`,
   {
    params,
  });

  return response.data;
};

// Staff Management APIs
export const updateStaff = async (staffData) => {
  const response = await engApi.get(`/staff`, {
    params: {
      action: 'update',
      ...staffData
    }
  });
  return response.data;
};

export const addStaff = async (staffData) => {
  const response = await engApi.get(`/staff`, {
    params: {
      action: 'add',
      ...staffData
    }
  });
  return response.data;
};

export const archiveStaff = async (staffId) => {
  const response = await engApi.get(`/staff`, {
    params: {
      action: 'archive',
      id: staffId
    }
  });
  return response.data;
};

// Coop Evaluation Detail API
export const getCoopEvaluationDetail = async (reqId) => {
  const response = await engApi.get(`/get-coop-evaluation-detail?req_id=${reqId}`);
  return response.data;
};

export const getCoopReportDetail = async (reqId) => {
  const response = await engApi.get(`/get-coop-report-detail?req_id=${reqId}`);
  return response.data;
};

